import { all, fork } from 'redux-saga/effects';
import authSagas from './modules/Auth/saga';

export default function* rootSagas() {
  yield all([fork(authSagas.fetchAuth)]);
}
